import React from "react";
import { Link } from "react-router-dom";
import Preguntas from "../Components/Preguntas";

const rouletteGames = [
  { "idtable": "3-7x0b1tgh7agmf6hv", "name": "Immersive Roulette",          "img": "evolution-3-lr6t4k3lcd4qgyrk-2.jpg" },
  { "idtable": "3-48z5pjps3ntvqc1b", "name": "Auto-Roulette",                "img": "evolution-3-48z5pjps3ntvqc1b-2.jpg" },
  { "idtable": "3-vctlz20yfnmp1ylr", "name": "Roulette",                      "img": "Roulette.jpg" },
  { "idtable": "3-wzg6kdkad1oe7m5k", "name": "VIP Roulette",                  "img": "VIP-Roulette.jpg" },
  { "idtable": "3-f1f4rm9xgh4j3u2z", "name": "Auto-Roulette La Partage",      "img": "Roulette.jpg" },
  { "idtable": "3-lkcbrbdckjxajdol", "name": "Speed Roulette",                "img": "Speed-Roulette.jpg" },
  { "idtable": "3-LightningSpain01", "name": "Ruleta Relámpago en Vivo",      "img": "Roleta-ao-Vivo.jpg" },
  { "idtable": "3-TRLRou0000000001", "name": "Türkçe Lightning Rulet",        "img": "turke.jpg" },
  { "idtable": "3-ovfzgqahvicqtiwu", "name": "Lightning Roulette Italia",     "img": "10951_4.jpg" },
  { "idtable": "3-PorROULigh000001", "name": "Roleta Relâmpago",              "img": "images.jpg" },
  { "idtable": "3-LightningHindi01", "name": "Hindi Lightning Roulette",      "img": "Hindi-Roulette.jpg" },
  { "idtable": "3-GoldVaultRo00001", "name": "Gold Vault Roulette",           "img": "French-Roulette-Gold.jpg" },
  { "idtable": "3-k37tle5hfceqacik", "name": "Bucharest Auto-Roulette",       "img": "Bucharest-Roulette.jpg" },
  { "idtable": "3-mkvhbciosnfqhat7", "name": "Arabic Roulette",               "img": "Arabic-Roulette.jpg" },
  { "idtable": "3-n4jwxsz2x4tqitvx", "name": "Japanese Roulette",             "img": "Japanese-Roulette.jpg" },
  { "idtable": "3-r5aw9yumyaxgnd90", "name": "Türkçe Rulet",                  "img": "turke.jpg" },
  { "idtable": "3-8clwnwrupuvf0osq", "name": "Ruleta en Vivo",                "img": "Ruleta-en-Vivo.jpg" },
  { "idtable": "3-PorROU0000000001", "name": "Roleta ao Vivo",                "img": "Ruleta-Bola-Rapida-en-Vivo.jpg" },
  { "idtable": "3-qtkjorzrlqeb6hrd", "name": "Deutsches Roulette",            "img": "Deutsches-Roulette.jpg" },
  { "idtable": "3-o4vjrhh5rtwimgi3", "name": "Greek Roulette",                "img": "evolution-3-mdkqijp3dctrhnuv-2.jpg" },
  { "idtable": "3-zosmk25g2f768o52", "name": "Ruletka Live",                  "img": "Ruletka-Live.jpg" },
  { "idtable": "3-rr0yhns3we03tqqu", "name": "Svensk Roulette",               "img": "Svensk-Roulette.jpg" },
  { "idtable": "3-oqa3v7a2t25ydg5e", "name": "Ruleta Bola Rapida en Vivo",   "img": "Ruleta-Bola-Rapida-en-Vivo.jpg" },
  { "idtable": "3-p675txa7cdt6za26", "name": "Ruleta en Español",             "img": "Ruleta-en-Español.jpg" },
  { "idtable": "3-7nyiaws9tgqrzaz3", "name": "Football Studio Roulette",      "img": "Football-Studio-Roulette.jpg" },
  { "idtable": "3-SpeedAutoRo00001", "name": "Speed Auto Roulette",           "img": "evolution-3-f1f4rm9xgh4j3u2z-2.jpg" },
  { "idtable": "3-mtnmxyvdxceqmllz", "name": "Suomalainen Ruletti",           "img": "Suomalainen-Ruletti.jpg" },
  { "idtable": "3-pv5q45yjhasyt46y", "name": "Emperor Roulette",              "img": "Emperor-Roulette.jpg" },
];

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {}

  render() {
    return (
      <>
        <main>

          {/* ── Hero ─────────────────────────────────────────── */}
          <section className="sb-hero" style={{ minHeight: '62vh', padding: '3rem 0' }}>
            <div className="container position-relative" style={{ zIndex: 1 }}>
              <div className="row align-items-center g-4">

                {/* Left */}
                <div className="col-lg-6 text-center text-lg-start sb-fade-in">
                  <div className="sb-hero-badge">
                    <span style={{ width: 7, height: 7, background: '#10b981', borderRadius: '50%', display: 'inline-block' }}></span>
                    Live Evolution Roulette data
                  </div>
                  <h1 className="sb-hero-title" style={{ fontSize: 'clamp(1.6rem, 4vw, 2.5rem)', marginBottom: '0.9rem' }}>
                    Statistics &amp; tracking for{' '}
                    <span className="accent">online roulette</span>
                  </h1>
                  <p className="sb-hero-sub" style={{ fontSize: '0.95rem', marginBottom: '1.5rem' }}>
                    Detailed real-time statistics on Evolution roulette tables — numbers, frequencies, hot &amp; cold trends, and more.
                  </p>
                  <div className="d-flex gap-2 flex-wrap justify-content-center justify-content-lg-start">
                    <Link to="/tables" className="btn-sb-primary">
                      Explore all tables
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"/>
                      </svg>
                    </Link>
                    <Link to="/pricing" className="btn-sb-outline">
                      View pricing
                    </Link>
                  </div>
                </div>

                {/* Right */}
                <div className="col-lg-6 text-center d-none d-lg-block">
                  <div className="sb-hero-img">
                    <img
                      src="https://yggdrasilgaming.com/w/files/2022/02/RouletteEvolution-Single-Game-Logo-750x540px.png"
                      alt="Evolution Roulette"
                      style={{ maxHeight: 320, width: '100%', objectFit: 'contain' }}
                    />
                  </div>
                </div>

              </div>
            </div>
          </section>

          {/* ── Table Grid ───────────────────────────────────── */}
          <section style={{ padding: '3rem 0', background: 'var(--sb-bg-surface)' }}>
            <div className="container">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                  <div className="sb-section-label" style={{ marginBottom: '0.2rem' }}>Live tables</div>
                  <h2 className="sb-section-title" style={{ fontSize: '1.3rem', marginBottom: 0 }}>Roulette tables</h2>
                </div>
                <Link to="/tables" className="btn-sb-outline" style={{ fontSize: '0.8rem' }}>
                  See all →
                </Link>
              </div>

              <div className="row g-3">
                {rouletteGames.slice(0, 6).map(item => (
                  <div key={item.idtable} className="col-12 col-sm-6 col-lg-4">
                    <Link to={`/table/${item.idtable}/${item.name}`} className="sb-table-card">
                      <div className="sb-table-card-img-wrap" style={{ height: 140 }}>
                        <div style={{ backgroundImage: `url(/assets/tables/${item.img})` }} />
                      </div>
                      <div className="sb-table-card-body" style={{ padding: '0.65rem 1rem' }}>
                        <p className="sb-table-card-title" style={{ fontSize: '0.85rem' }}>{item.name}</p>
                      </div>
                      <div className="sb-table-card-footer" style={{ padding: '0.45rem 1rem' }}>
                        Evolution Gaming
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ── Pricing ──────────────────────────────────────── */}
          <section style={{ padding: '3rem 0' }} id="pricing">
            <div className="container">
              <div className="text-center mb-4">
                <div className="sb-section-label">Pricing</div>
                <h2 className="sb-section-title" style={{ fontSize: '1.4rem' }}>Simple, transparent pricing</h2>
                <p className="sb-section-sub" style={{ marginBottom: 0 }}>Access all data from all tables with one subscription</p>
              </div>

              <div className="row g-3 justify-content-center">

                {/* Simple plan */}
                <div className="col-12 col-md-5">
                  <div className="sb-pricing-card" style={{ padding: '1.5rem' }}>
                    <p className="sb-pricing-name">Simple plan</p>
                    <div className="d-flex align-items-baseline gap-1 mb-1">
                      <span className="sb-pricing-currency">€</span>
                      <span className="sb-pricing-price" style={{ fontSize: '2.2rem' }}>10</span>
                    </div>
                    <p className="sb-pricing-period">per month · billed monthly</p>
                    <hr className="sb-pricing-divider" style={{ margin: '1rem 0' }} />
                    <ul className="sb-feature-list" style={{ marginBottom: '1.25rem' }}>
                      <li><span className="sb-feature-check">✓</span>Access to all roulette tables</li>
                      <li><span className="sb-feature-check">✓</span>Last 2 months of statistics</li>
                      <li><span className="sb-feature-check">✓</span>Limited lifetime analysis</li>
                    </ul>
                    <Link to="/login" className="btn btn-dark w-100">Get started</Link>
                  </div>
                </div>

                {/* Premium plan */}
                <div className="col-12 col-md-5">
                  <div className="sb-pricing-card featured" style={{ padding: '1.5rem' }}>
                    <div className="sb-pricing-badge">Best value</div>
                    <p className="sb-pricing-name">Premium plan</p>
                    <div className="d-flex align-items-baseline gap-1 mb-1">
                      <span className="sb-pricing-currency">€</span>
                      <span className="sb-pricing-price" style={{ fontSize: '2.2rem' }}>20</span>
                    </div>
                    <p className="sb-pricing-period">per month · billed monthly</p>
                    <hr className="sb-pricing-divider" style={{ margin: '1rem 0' }} />
                    <ul className="sb-feature-list" style={{ marginBottom: '1.25rem' }}>
                      <li><span className="sb-feature-check">✓</span>Access to all roulette tables</li>
                      <li><span className="sb-feature-check">✓</span>Full lifetime statistics</li>
                      <li><span className="sb-feature-check">✓</span>Unlimited lifetime analysis</li>
                      <li><span className="sb-feature-check">✓</span>Deep-analytics insights</li>
                      <li><span className="sb-feature-check">✓</span>API access to database</li>
                      <li><span className="sb-feature-check">✓</span>24/7 Support</li>
                    </ul>
                    <Link to="/login" className="btn btn-primary w-100">Get started</Link>
                  </div>
                </div>

              </div>
            </div>
          </section>

          {/* ── FAQ ──────────────────────────────────────────── */}
          <Preguntas />

          {/* ── SEO text ─────────────────────────────────────── */}
          <section style={{ padding: '1.5rem 0 3rem' }}>
            <div className="container">
              <div style={{
                background: 'var(--sb-bg-surface)',
                border: '1px solid var(--sb-border)',
                borderRadius: 'var(--sb-radius-lg)',
                padding: '1.5rem 2rem',
              }}>
                <h5 style={{ color: 'var(--sb-text-primary)', marginBottom: '0.5rem', fontSize: '0.95rem' }}>
                  Statistics and real-time roulette tracking
                </h5>
                <p style={{ color: 'var(--sb-text-secondary)', fontSize: '0.82rem', lineHeight: '1.7', margin: 0 }}>
                  Follow live statistics of roulette games from leading developers such as Evolution, Ezugi, Pragmatic, and Playtech — including number frequency, colors, dozens, neighbors, sectors, and more.
                  A useful tool for analyzing trends and patterns, helping players make more informed decisions in real time.
                </p>
              </div>
            </div>
          </section>

        </main>
      </>
    );
  }
}

export default Landing;
